// Module
var code = "<select flex ng-model=\"billingItemGroup.quantity\" ng-change=\"vm.calculateBudgetEstimate()\"> <option ng-repeat=\"billingItemValue in billingItemGroup\" ng-value=\"billingItemValue.start\"> {{ getRangeLabel(billingItemValue) }} </option> </select> <span class=\"very-hidden\">{{ 'marketplace.billing-items.over' | translate }}</span> ";
// Exports
var _module_exports = code;;
var path = 'views/marketplace/marketplace-product-billing-items-common.select.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;